/**
 * Hero Video Autoplay Enhancement
 * Ensures reliable autoplay on mobile browsers with strict policies
 */

document.addEventListener('DOMContentLoaded', function() {
  const videoElements = document.querySelectorAll('.hero-video');

  if (!videoElements.length) return;

  // Function to attempt video play
  function attemptPlay(video) {
    if (video.tagName === 'VIDEO') {
      // Native HTML5 video
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(error => {
          // Autoplay was prevented, retry after a short delay
          console.log('Autoplay prevented, retrying...', error);
          setTimeout(() => {
            video.play().catch(e => console.log('Retry failed:', e));
          }, 100);
        });
      }
    }
  }

  // Use Intersection Observer to play when video is visible
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1 // Trigger when 10% of video is visible
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;

        // For native video elements
        if (video.tagName === 'VIDEO') {
          attemptPlay(video);

          // Also try playing on any user interaction
          const playOnInteraction = () => {
            attemptPlay(video);
            document.removeEventListener('touchstart', playOnInteraction);
            document.removeEventListener('click', playOnInteraction);
          };

          document.addEventListener('touchstart', playOnInteraction, { once: true });
          document.addEventListener('click', playOnInteraction, { once: true });
        }
      }
    });
  }, observerOptions);

  // Observe all video elements
  videoElements.forEach(video => {
    if (video.tagName === 'VIDEO') {
      observer.observe(video);

      // Also attempt immediate play
      attemptPlay(video);
    }
  });

  // Additional fallback: Try playing after page fully loads
  window.addEventListener('load', () => {
    videoElements.forEach(video => {
      if (video.tagName === 'VIDEO') {
        setTimeout(() => attemptPlay(video), 500);
      }
    });
  });
});
